
export interface IAttribute {
    atributoID: number | null;
    atributoGUID?: string | null;
    departamentoID: number;
    departamentoNombre: string | null;
    departamentoGUID?: string;
    nombre: string;
    descripcion: string;
    atributoTipo: TypeAttribute;
    atributoTipoNombre?: string | null;
    atributoDetalle: IAtributoDetalle[];
}

export interface IAtributoDetalle {
    atributoDetalleID: number | null;
    atributoID: number | null;
    atributoValor: string;
}

export enum TypeAttribute {
    Detalle = 1,
    Texto = 2
}
